<template>
  <div>
    <transition name="fade" mode="out-in">
      <div 
        v-if="isLoading"
        class="center-screen"
        key="main_screen">
          <div :style="`padding:20px;minheight:400px`">
            <img class="index-logo" src="static/indexnoslus.svg">
          </div>
      </div>
      <!-- SIGNATURE -->
      <div v-else-if="showWindow==='signature'" v-loading.fullscreen.lock="savingBtn" id="div_signature" key="signature_screen">
        <!-- <signature v-else-if="showWindow==='signature'" @saveSign="saveForm" :loading_btn="savingBtn"></signature> -->
        <hm-signature :show="signDialogVisible" @close="signDialogVisible = false" @save="saveForm"/> <!--  novy sign component -->
      </div>
      <div v-else key="other_screen">
        <!-- info a error spravy -->
        <div v-if="dataLogin.showErr" class="center-screen">
          <div
            :style="`padding:20px;width:${window_width >= 462 ? 442 : window_width - 40}px;minheight:400px`"
            :class="`${window_width >= 462 ? 'el-card is-always-shadow' : 'el-card'}`">
            <img class="index-logo" src="static/indexnoslus.svg">
            <h4 style="margin-top:70px;color:#E30015">{{dataLogin.server_err_mesage}}</h4>
            <transition name="fade">
              <div v-show="dataLogin.showErr">{{dataLogin.server_err_description}}</div>
            </transition>
          </div>
        </div>
        <div class="center-screen" v-else>
          <!-- LOGIN WINDOW -->
          <div
            v-if="showWindow=='login'"
            :style="`padding:20px;width:${window_width >= 462 ? 442 : window_width - 40}px;minheight:400px`"
            :class="`${window_width >= 462 ? 'el-card is-always-shadow' : 'el-card'}`"
          >
            <login-screen
              :data="dataLogin"
              :pin="pin"
              :showSendPin="showSendPin"
              :disableSendPin="disableSendPin"
              :isDisabledPin="isDisabledPin"
              :macro="macro"
              @btnLogin="detailForm"
              @btnResend="authForm('resend')"
              @pin="handlePin"
            ></login-screen>
          </div>
          <!-- FORM WINDOW -->
          <div v-if="showWindow=='form'"
            :class="`${window_width >= 850 ? 'el-card is-always-shadow' : ''}`"
            :style="`padding:20px;width:${window_width > 462 ? 'calc(90% - 40px)' : 'calc(100%)'};`"
          >
            <img class="index-logo" src="static/indexnoslus.svg">
            <h3 style="margin-top:30px;">Vyplňte údaje pro prohlášení poplatníka</h3>
            <h4 style="color:#eb4c4e;margin-bottom:40px;">Pole označená * jsou povinná</h4>
            <!-- FORMULAR KOMPONENTA -->
            <taxpay-form
              v-if="showWindow=='form'"
              ref="formEmp"
              @save="showWindow='signature';signDialogVisible=true;"
              :dataForm="dataForm"
              :optData="{
                list: list,
                macro: macro,
                headers: {
                  'X-PIN': pin,
                },
              }">
              <!-- UPLOAD -->
              <!-- <template v-slot:upload>
                <el-divider>
                  Přílohy
                  <el-tooltip placement="top" effect="light">
                    <i class="far fa-question-circle tool-tip-form"></i>
                    <div slot="content">Zde vložte přílohy, napr.: kopii držitele průkazu ZTP/P, potvrzení o studiu apod.</div>
                  </el-tooltip>
                </el-divider>
                <el-row style="text-align:left">
                  <el-col :span="24">
                    <el-upload id="hm" style="padding-left:0px;padding-top:20px"
                      drag
                      multiple
                      ref="upload"
                      :fileList="uload_fileList"
                      :action="upload_url"
                      :on-success="uploadSuccess"
                      :on-error="uploadError"
                      :on-change="uploadChange"
                      :on-remove="uploadRemove"
                      :headers="{'X-PIN': pin}"
                      :data="{
                        form_id: formID
                      }"
                      :auto-upload="false">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">Sem přetáhněte soubor nebo <em> kliknutím nahrajte</em></div>
                      <div class="el-upload__tip" slot="tip">
                        <div style="line-height:18px">Celková velikost všech souborů může být max 14MB</div>
                        <div v-if="upload_sum_file>0" style="line-height:14px">
                          Aktuální celková velikost {{parseFloat((upload_size_file / 1024 / 1024).toFixed(2))}}MB v počtu příloh: {{upload_sum_file}}
                        </div>
                      </div>
                    </el-upload>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
              </template> -->
            </taxpay-form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */
/* eslint-disable template-curly-spacing */
import { authForm } from '@/api/form'
import { detailForm, updateForm } from '@/api/formtaxpay'
import validity from '@/components/HMEmployeeForm/mixins/validity'
import TaxPayForm from './components/taxpay'
import signature from './components/signature'
import HMSignature from '@/components/HMSignature'
import LoginScreen from '@/components/WebLogin/login'

export default {
  name: 'WebForm',
  mixins: [validity],
  components: {
    'taxpay-form': TaxPayForm,
    'login-screen': LoginScreen,
    'hm-signature': HMSignature,
    signature
  },
  data () {
    return {
      list: false, // ked sa nastavi na true, zacnu sa nacitavat ciselniky
      isLoading: true,
      showSendPin: true,
      disableSendPin: false,
      // cardStyle_form: {
      //   'padding': '20px',
      //   'width': 'calc(100% - 60px)',
      //   'clientWidth': 850
      // },
      pin: '',
      macro: '',
      listMessage: [
        this.$t(`webform.msg.list1`),
        this.$t('webform.msg.list2'),
        this.$t('webform.msg.list3'),
        this.$t('webform.msg.list4')
      ],
      nr_message: 0,
      dataLogin: {
        show_message: '',
        showMsg: false,
        showErr: false,
        server_err_mesage: '',
        server_err_description: '',
        color: {
          set: 'normal',
          normal: '#303133',
          error: '#E30015'
        }
      },
      msg_timeout: undefined,
      isDisabledPin: true,
      showWindow: 'login', // 'login',
      dataForm: {
        tax_period_month: undefined,
        tax_period_year: undefined,
        tax_period: undefined, // this.$moment(new Date()).format('YYYY'),
        payer_name: 'INDEX NOSLUŠ s.r.o.',
        payer_address: 'Hornokrčská 583/30, 140 00 Praha 4',
        taxpayer_address: '',
        is_resident: true,
        discount: [1],
        is_benefits_for_children: false,
        benefits_for_children: [{}],
        is_other_taxpayer: false,
        other_taxpayer: {}
      },
      signDialogVisible: false,
      savingBtn: false, // loading na tlacitku PODEPSAT
      window_width: 500, // sirka okna prehliadaca
      window_height: 0, // vyska okna prehliadaca
      canvas_width: 875, // sirka canvas podpisu
      canvas_height: 350, // vyska canvas podpisu
      uploadLimit: false, // ak sa prekroci Limit uploadu, bude true
      upload_url: process.env.BASE_API + '/form_taxpay/file_upload?form_id=' + this.$route.params.formID,
      upload_max_size: 14336, // max kapacita priloh v kB
      uload_fileList: [], // sem sa vklada zoznam uz nauploadovanych suborov ulozenych uz na serveri
      upload_count_file: 0, // pocitadlo kolko novych suborov sa aktualne prilozilo
      upload_size_file: 0, // velkost vsetkych priloh dokopy vcetne tych v DB
      upload_sum_file: 0, // pocet vsetkych priloh dokopy vcetne tych v DB
      /**
       * upload_remove_file:
       *  ked uchadzac odobere subor, ktory uz bol uploadovany do form.data.files, sem sa poznaci _id a po kliknuti
       *  na ULOZIT, sa na serveri odstrania prilohy s tymito _id. Jedna sa len o prilohy, ktore maju status: 'success'
       */
      upload_remove_file: [],
      formID: this.$route.params.formID
    }
  },
  computed: {
  },
  watch: {
    pin: function (newVal) {
      if (newVal.length > 0) {
        this.showSendPin = false // schovaj btn poslat PIN znovu
        if (!this.validNumeric(newVal)) {
          if (this.msg_timeout) {
            clearTimeout(this.msg_timeout)
          }
          this.dataLogin.showMsg = false
          this.msg_timeout = setTimeout(() => {
            this.nr_message = 1
            this.dataLogin.color.set = 'error'
            this.dataLogin.show_message = this.listMessage[this.nr_message]
            this.dataLogin.showMsg = true
          }, 600)
        } else {
          this.isDisabledPin = false
          this.confirmValid()
        }
      } else {
        this.confirmValid()
        this.showSendPin = true // ukaz btn poslat PIN znovu
        this.isDisabledPin = true
      }
    },
    'dataForm.country_id': function (newCountryId) {
      if (!this.dataForm.citizenship_id) {
        this.dataForm.citizenship_id = newCountryId
      }
    },
    upload_count_file: function (newVal) {
      console.log(`[WebForm.vue] pocet suborov pripravenych na upload =>`, newVal, `/`, this.upload_sum_file)
    },
    upload_size_file: function (newSize) {
      console.log(`[WebForm.vue] velkost vsetkych priloh vcetne ulozenych v DB =>`, newSize / 1024, `kB`)
      if ((newSize / 1024) > this.upload_max_size) {
        this.uploadLimit = true
      } else {
        this.uploadLimit = false
      }
    },
    uploadLimit: function () {
      this.handleDisabledBtnSave()
    },
    'dataForm.isGDPR': function () {
      this.handleDisabledBtnSave()
    },
    showWindow: function (newVal) {
      if (newVal === 'signature') {
        window.scrollTo(0, 0)
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', () => {
        let width = window.innerWidth
        this.window_height = window.innerHeight
        this.handleWindowSize(width)
      })
    })
  },
  created () {
    this.dataLogin.show_message = this.listMessage[this.nr_message]
    // console.log(this.dataLogin.show_message)
    if (this.validLink()) { // kontrola validity na klientskej strane
      this.authForm()
    }
    else {
      this.handleError({ status: 500, data: { error: { err_code: 2 } } })
      this.isLoading = false
    }
    setTimeout(() => {
      this.dataLogin.showMsg = true
    }, 800)
    // --- INIT ---
    this.handleWindowSize(window.innerWidth)
  },
  methods: {
    handleDisabledBtnSave () {
      this.disableBtn = true
      if (this.uploadLimit === false && this.dataForm.isGDPR === true) {
        this.disableBtn = false
      }
    },
    handleWindowSize (p_width) {
      // *** nastavenia pre formular
      // this.cardStyle_form.clientWidth = p_width // nastav skutocnu sirku obrazovky
      // this.cardStyle_form.width = p_width < 482 ? 'calc(100% - 5px)' : '90%' // okraje login okna pri desktope a mobile
      // this.cardStyle_form.shadow = p_width > 850 ? 'always' : 'none' // desktop => zobraz tien pod el-card : maly displej(mobil) => vypni tien pod el-card
      // this.cardStyle_form.padding = p_width > 850 ? '30px' : '2px' // desktop => je padding 30px : maly displej(mobil) => je padding 2px
      // ---
      this.window_width = p_width
      // ---
    },
    confirmValid () {
      // eslint-disable-next-line eqeqeq
      if (this.nr_message == 0) return
      if (this.msg_timeout) {
        clearTimeout(this.msg_timeout)
      }
      this.dataLogin.showMsg = false
      this.msg_timeout = setTimeout(() => {
        this.nr_message = 0
        this.dataLogin.color.set = 'normal'
        this.dataLogin.show_message = this.listMessage[this.nr_message]
        this.dataLogin.showMsg = true
      }, 600)
    },
    validLink () { // je linka este platna?
      if (this.$route.params.expiration) {
        let expiration = this.$route.params.expiration
        let nowtimestamp = this.$moment().valueOf()
        if (nowtimestamp < expiration) {

          return true // validna
        } else {

          return false // nevalidna
        }
      } else {

        return false // nevalidna
      }
    },
    authForm (p_only_resend) { // overuje odkaz a posle PINkod
      let query = {
        form_id: this.$route.params.formID,
        expiration: this.$route.params.expiration,
        pin_resend: p_only_resend || undefined,
        form_type: 'form_taxpay'
      }
      if (p_only_resend === 'resend') {
        this.disableSendPin = true
        this.nr_message = 3
        this.dataLogin.show_message = this.listMessage[this.nr_message]
        setTimeout(() => {
          this.disableSendPin = false
          this.nr_message = 0
          this.dataLogin.show_message = this.listMessage[this.nr_message]
        }, 10000)
      }
      authForm(query).then((response) => {
        this.macro = (response.headers && response.headers['x-macro']) || ''
        this.listMessage[0] = this.$t(`webform.msg.${this.macro}_list1`)
        this.listMessage[1] = this.$t(`webform.msg.${this.macro}_list2`)
        this.listMessage[2] = this.$t(`webform.msg.${this.macro}_list3`)
        this.dataLogin.show_message = this.listMessage[this.nr_message]
        let result = response.data
        this.pin = (result && result.temp_pin) || this.pin
        if (this.pin && this.pin !== '') {
          this.detailForm()
        } else {
          // HOTOVO
          this.isLoading = false
        }
      })
        .catch((err) => {
          this.isLoading = false
          console.error(`[webform.vue] authForm ! err`, err)
          this.handleError(err)
        })
    },
    detailForm () {
      let form_id = this.$route.params.formID
      let headers = {
        'X-PIN': this.pin
      }
      detailForm({form_id: form_id}, headers).then((response) => {
        this.dataForm = Object.assign({}, this.dataForm, response.data.data)
        this.macro = (response.headers && response.headers['x-macro']) || ''

        if (this.dataForm.benefits_for_children.length === 0) {
          this.dataForm.benefits_for_children = [{}]
        }
        this.showWindow = 'form'
        this.isLoading = false
      })
        .catch((err) => {
          this.isLoading = false
          console.error(`[webform.vue] detailForm ! err`, err)
          this.handleError(err)
        })
    },
    handleError (err) {
      // chyby sa zobrazia v login okne nad inputom
      if (err.status === 500) {
        if (err.data && err.data.error.err_code === 1) { // PIN is not valid for form ID.
          this.nr_message = 2
          this.dataLogin.show_message = this.listMessage[this.nr_message]
          this.dataLogin.color.set = 'error'
        }
      }
      // chyba zmizne za 7 sek
      setTimeout(() => {
        this.nr_message = 0
        this.dataLogin.show_message = this.listMessage[this.nr_message]
        this.dataLogin.color.set = 'normal'
      }, 7000)
      // ---
      // chyby sa zobrazia ako samostany el-card(okienko)
      if (err.toString() === 'Network Error') {
        this.dataLogin.showErr = true
        this.dataLogin.server_err_mesage = this.$t('webform.msg.err_link_title')
        this.dataLogin.server_err_description = this.$t('webform.msg.err_link_desc')
        setTimeout(() => {
          this.dataLogin.showErr = false
        }, 5000)
      }
      if (err.status === 500) {
        console.log('error 500', err)
        if (err.data && err.data.error.err_code === 2) { // vyprsalo casove okno, The link has expired.
          this.dataLogin.showErr = true // zobraz samostatne okienko s chybou
          this.dataLogin.server_err_mesage = this.$t('webform.msg.err_link_title1')
          this.dataLogin.server_err_description = this.$t('webform.msg.err_link_desc1')
        }
        if (err.data && err.data.error.err_code === 3) { // blby odkaz, Illegal link duration manipulation!
          this.dataLogin.showErr = true // zobraz samostatne okienko s chybou
          this.dataLogin.server_err_mesage = this.$t('webform.msg.err_link_title2')
          this.dataLogin.server_err_description = this.$t('webform.msg.err_link_desc2')
        }
        if (err.data && err.data.error.err_code === 4) { // data formularu uz schvalil uzivatel
          this.dataLogin.showErr = true // zobraz samostatne okienko s chybou
          this.dataLogin.server_err_mesage = this.$t('webform.msg.err_link_title3')
          this.dataLogin.server_err_description = this.$t('webform.msg.err_link_desc3')
        }
        if (err.data && err.data.error.err_code === 5) { // ostatne chyby
          this.dataLogin.showErr = true // zobraz samostatne okienko s chybou
          this.dataLogin.server_err_mesage = this.$t('webform.msg.err_link_title4')
          this.dataLogin.server_err_description = this.$t('webform.msg.err_link_desc4') // err.data.error.err_message
        }
        // update - saveForm => zobrazi sa notify okno
        if (err.data && err.data.error.err_code === 6) { // ostatne chyby pri ukladani
          this.$notify({
            title: this.$t('webform.lbl.title'),
            message: this.$t('webform.msg.err_not_save'),
            type: 'error'
          })
        }
      }
    },
    saveForm (p_signature) {
      this.savingBtn = true
      let form_id = this.$route.params.formID
      let headers = {
        'X-PIN': this.pin
      }
      this.dataForm.form_id = form_id
      this.dataForm.img_sign = p_signature // p_signature.img.data
      updateForm(this.dataForm, headers).then((response) => {
        // A. ak su nejake subory na upload
        if (this.upload_count_file > 0) {
          this.$refs.upload.submit() // zacni uploadovat
        }
        else { // inak
          this.formDone() // podakuj a ukonci formular
        }
      })
        .catch((err) => {
          console.error(`[webformTaxPay.vue] saveForm ! err`, err)
          this.handleError(err)
          this.savingBtn = false
        })
    },
    uploadSuccess (p_response, p_file, p_fileList) {
      let countSuccess = 0
      for (let index = 0; index < p_fileList.length; index++) {
        const file = p_fileList[index]
        if (file.status === 'success') {
          countSuccess++
        }
      }
      if (countSuccess === p_fileList.length) {
        this.formDone() // ak vsetky prilohy maju status success, podakuj a ukonci formular
      }
    },
    uploadChange (p_file, p_fileList) {
      // console.log("file", p_file)
      // console.log("fileList CHANGE", p_fileList)
      this.upload_count_file = 0
      this.upload_size_file = 0
      this.upload_sum_file = 0
      for (let index = 0; index < p_fileList.length; index++) {
        const file = p_fileList[index]
        if (file.status === 'ready') {
          this.upload_count_file++ // celkom priloh na upload
        }
        this.upload_size_file += file.size // velkost vsetkych suborov spolu
        this.upload_sum_file++ // celkom priloh vcetne tych v DB
      }
    },
    uploadRemove (p_file, p_fileList) {
      // console.log("fileList REMOVE", p_fileList)
      if (p_file.status === 'success') {
        this.upload_remove_file.push(p_file._id)
      }
      this.upload_count_file = 0
      this.upload_size_file = 0
      this.upload_sum_file = 0
      for (let index = 0; index < p_fileList.length; index++) {
        const file = p_fileList[index]
        if (file.status === 'ready') {
          this.upload_count_file++ // celkom priloh na upload
        }
        this.upload_size_file += file.size // velkost vsetkych suborov spolu
        this.upload_sum_file++ // celkom priloh vcetne tych v DB
      }
    },
    uploadError (p_err, p_file, p_fileList) {
      this.$notify({
        title: 'Přílohy',
        message: `Při odesílaní přílohy nastala chyba. Soubor ${p_file.name} se nepodařilo uploadovat, zkuste to prosím znovu.`,
        type: 'warning'
      })
      this.savingBtn = false
    },
    formDone () {
      this.savingBtn = false
      this.showWindow = 'Koniec' // uz nezobrazi nic...
      this.dataLogin.showErr = true // ...zobrazi sa samostatne okienko s podakovanim
      this.dataLogin.server_err_mesage = 'Formulář odeslán.'
      this.dataLogin.server_err_description = 'Formulář prohlášení poplatníka byl úspěšně zpracován. Děkujeme Vám za vyplnění.'
    },
    openURL (p_url) {
      window.open(p_url, '_blank')
    },
    handlePin (p_pin) {
      this.pin = p_pin
    }
  }
}
</script>

<style>
body {
  margin: 0px;
  background-color: #F9F9F9;
}
.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 90vh;
}
.index-logo {
  height: 40px;
  width: auto;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-confirm-disabled {
  background-color:#eb4c4e !important;
  border: 0px;
  color:whitesmoke !important;
}
.btn-confirm-disabled:hover {
  background-color:#eb4c4e;
  color:whitesmoke;
}
.btn-confirm {
  background-color:#E30015;
  border: 0px;
  color:whitesmoke;
}
.btn-confirm:hover {
  background-color:hsla(354, 100%, 45%, 0.822);
  color:whitesmoke;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
#hm .el-upload {
  width: calc(100%) !important;
}
#hm .el-upload-dragger {
  width: 100% !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-to, .fade-leave {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/WebFormTaxPay/WebFormTaxPay.vue